import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styles: [
  ]
})
export class MaintenanceComponent implements OnInit {

  public activeRoute: string; 

  constructor( ) { }

  ngOnInit(): void {
    localStorage.removeItem('searchTag');
  }

}
